<template>
  <div class="header-container">
    <div class="title_box">
      <img class="title_box_img" src="../assets/index/yblogo@2x.png" @click="to_index" alt="">
      <span style="font-size: 12px;color: #777777; margin-top: 4px;">上海悦高软件股份有限公司全资子公司</span>
    </div>
    <div class="dlzc_box">
    <a href=""></a>
    <span class="header_button" :class="{ 'header_button_active': activeNavButton === 'index' }" @click="to_index">&nbsp;&nbsp;首页&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span class="header_button" :class="{ 'header_button_active': activeNavButton === 'download' }" @click="to_download">&nbsp;&nbsp;产品下载&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span class="header_button" :class="{ 'header_button_active': activeNavButton === 'introduce' }" @click="to_introduce">关于我们&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <!--    <span v-if="username" class="header_button">{{username}}</span>-->
    <el-dropdown v-if="username" class="user-dropdown" trigger="manual" :visible="userMenuVisible"
                 :hide-on-click="false">
        <span class="el-dropdown-link" @mouseenter="keepUserMenuOpen" @mouseleave="delayHideUserMenu">
          <img class src="@/assets/index/tx@2x.png" alt=""/>
          <span>{{ nickname }}</span>
          <i class="el-icon-caret-bottom" style="font-size: 14px"></i>
        </span>
      <template #dropdown>
        <div class="my_center" @mouseenter="keepUserMenuOpen" @mouseleave="delayHideUserMenu">
          <div class="my_center_top">
            <div class="my_center_top_left" style="float: left;">
              <div :class="my_version_class">{{ acc_type_zh }}</div>
              <div v-if="acc_type==='1'" class="my_date" style="color:#BA0B0B;">{{ expiration_date }} 到期</div>
              <div v-else class="my_date">
                <span v-if="expiration_date.slice(0, 4) === '2999' "  class="expiration_date_text">
                  期限:永久
                </span>
                <span v-else class="expiration_date_text">{{
                    expiration_date.slice(0, 10)
                  }} 到期</span>


              </div>
            </div>
            <div class="my_center_top_right">
              <el-button class="xf_btn" v-if="my_xf_btn===true" type="primary" size="small"
                         round
                         @click="showBuy('zy')"
                         style="float: right;margin-right: 10px;margin-top: 13px;background-color: #BA0B0B">
                立即续费
              </el-button>
              <el-button class="gm_btn" v-if="my_xf_btn===false" size="small"
                         round
                         @click="showBuy('zy')"
                         style="float: right;margin-right: 10px;margin-top: 13px; color: #040404">
                立即升级
              </el-button>
            </div>
          </div>
          <div class="my_center_bottom">
            <div class="my_center_bottom_left" style="float: left;">
              <div class="my_grzx my_cz_box" @click="to_my_center"
                   style="cursor: pointer!important;">
                <img class="xl-grzx-tag-icon" src="../assets/index/frzx@2x.png" alt="个人中心"/>
                <div style="margin-top: 5px">个人中心</div>
              </div>
              <div class="my_xgmm my_cz_box"
                   style="border-right: 1px solid #EFEFEF">
                <img class="xl-grzx-tag-icon" src="../assets/index/wdjy@2x.png" alt="我的交易"/>
                <div style="margin-top: 5px">我的交易</div>
              </div>
            </div>
            <div class="my_center_bottom_right" style="float: right;">
              <div class="my_tc my_cz_box"
                   style="" @click="loginOut">
                <img class="xl-grzx-tag-icon" src="../assets/index/tc@2x.png" alt="退出"/>
                <div style="margin-top: 5px">退出</div>
              </div>
            </div>
          </div>

        </div>
      </template>
    </el-dropdown>
    <div>
      <el-button v-if="!username" class="register_btn" size="small" @click="to_register">注册</el-button>
      <el-button v-if="!username" class="login_btn" size="small" @click="to_login">登录</el-button>
    </div>

    <el-dialog
        v-model="buyBoxShow"
        :width="isMobile ? '90%' : '20rem'"
        top="2rem"
        custom-class="responsive-dialog"
    >
      <template #title>
        <span style="color: #2A2A2A;font-size: 14px;font-weight: 600;float: left;">充值账号：</span>
        <div class="cz_user_box" style="display: inline-block;line-height: 30px;float: left;margin-top: 14px">
          <img class src="@/assets/index/tx@2x.png"
               style="display: inline-block;margin-right: 5px;float: left;margin-top: 2px;width: 32px;" alt=""/>
          <div class="cz_user_info" style="display: inline-block;line-height: 30px;float: left">
            <span style="color: #666666;display: block;font-size: 14px;line-height: 14px;margin-bottom: 5px">{{
                username
              }}</span>
            <span v-if="expiration_date.slice(0, 4) === '2999' && this.acc_type === '0'" style="color: #9C9C9C;display: block;font-size: 12px;line-height: 12px">期限:永久</span>
            <span v-else style="color: #9C9C9C;display: block;font-size: 12px;line-height: 12px">{{
                expiration_date
              }} 到期</span>
          </div>

        </div>
        <br>
      </template>
      <div class="version_card_box">
<!--        <div class="version_card" :class="version_card_bnk_00" style="float: left;"-->
<!--             @click="version_card_click(pay_price_jc,'0',365)">-->
<!--          <span :class="version_card_bnk_01">基础版</span>-->
<!--          <span :class="version_card_bnk_02">初始模拟资金30万</span>-->
<!--          <span :class="version_card_bnk_03">¥ <span :class="version_card_bnk_04"-->
<!--          >{{ pay_price_jc }}</span> 元</span>-->
<!--        </div>-->

        <div class="version_card" :class="version_card_nk_00"
             @click="version_card_click(pay_price_bj,'1',365)">
          <span :class="version_card_nk_01">专业版</span>
          <span :class="version_card_nk_02">初始模拟资金100万</span>
          <span :class="version_card_nk_03">¥ <span :class="version_card_nk_04"
          >{{ pay_price_bj }}</span> 元
          <span v-if="zy_discount_flag==='1'" style="font-size: 12px;">限时{{zy_discount_rate}}折</span></span>

        </div>

      </div>

    <div class="version_pay_box" style="display: flex; flex-wrap: wrap; justify-content: center; max-width: 100%;">
      <div class="version_pay_left">
        <div class="version_pay_qrcode">
          <div style="height: 120px"><img id="wx_tpid"
                                      :src="pay_qr_code"
                                      style="width: 120px;"></div>
          <div style="display: inline-block;height: 24px">
            <img src="@/assets/index/wx@2x.png" alt="" style="float: left;width: 24px;margin-right: 5px">
            <span style="float: left;line-height: 24px">微信扫码支付</span>
          </div>
        </div>
      </div>
      <div class="version_pay_right">
        <span style="display: block;color: #A9A9A9;line-height: 22px;">应付金额:</span>
        <span style="display: block;color: #EF4444;line-height: 30px;">¥ <span
            style="font-size: 32px;">{{ pay_price*zy_discount_rate/10 }}</span> 元</span>
        <span
            style="display: block;color: #434343;line-height: 12px;margin-bottom: 20px">*购买提示:一经使用，概不退费</span>
      </div>
    </div>
      <template #footer>

      </template>
    </el-dialog>

    <el-dialog
        v-model="buyReShow"
        width="13rem"
        top="2rem"
    >
      <div class="zf_success_box">

        <div class="success_1" style="text-align: center;height: 30px">
          <div style="display: inline-block;height: 36px">
            <img class="zfcg_img" src="@/assets/index/zfcg@1x.png" alt="" style="float: left;width: 36px;margin-right: 5px">
            <span class="zfcg_text" style="float: left;line-height: 36px;color: #232323">支付成功</span>
          </div>

        </div>
        <div class="success_2" style="color:#9C9C9C;text-align: center">可到“个人中心”一“账户管理”中查看详情</div>
        <div class="success_3" style="text-align: center">
          <el-button
              @click="showBuy('zy')"
              type="danger"
              size="medium" plain
          >继续购买
          </el-button
          >
          <el-button type="danger" size="medium" @click="buyReShow=false"
          >关 闭
          </el-button>
        </div>

      </div>

      <template #footer>

      </template>
    </el-dialog>
    </div>
  </div>
</template>
<script>
import {ElMessage} from "element-plus";
import {login_out} from "@/api/login_out/login_out";
import {
  csrc_reset_password
} from "@/api/index/index";

import {
  wx_zf_re, sys_user_me, order_bill_create, sys_app_get_price, refresh_token, product_price
} from "@/api/system/system";


export default {
  components: {},
  inject: ["reload"],
  data() {
    return {
      username: "",
      nickname: "",
      acc_type: "",
      acc_type_zh: "",
      my_xf_btn: false,
      // 导航按钮点击状态
      activeNavButton: '',


      pay_price_jc: 0, // 469 899
      pay_price_bj: 0, // 469 899

      gr_sale_flag:"0",
      zy_sale_flag:"0",

      zy_discount_flag:"0",
      zy_discount_rate:10,

      // 购买相关
      buyBoxShow: false,
      my_version_class: "my_version_wx",  // my_version_yx有效  my_version_wx 无效
      version_name: "专业版",
      // // version_date: "2024-12-30到期",
      // version_date: "2024-11-30已过期",

      pay_price: 469, // 469 899
      pay_days: 180, // 469 899
      order_type: 'bnk', // bnk半年卡 nk年卡
      expiration_date: '--',
      userid: '',
      pay_qr_code: "",
      version_card_bnk_00: "version_card_chose",
      version_card_bnk_01: "",
      version_card_bnk_02: "",
      version_card_bnk_03: "",
      version_card_bnk_04: "",
      version_card_nk_00: "version_card_unset",
      version_card_nk_01: "",
      version_card_nk_02: "",
      version_card_nk_03: "",
      version_card_nk_04: "",
      buyReShow: false,
      zfjgTimerId: null,
      wx_ddh: "",
      // 购买相关结束


      url: "",
      // 面包屑导航数据源
      breadcrumbList: [],
      updatepwdShow: false,
      token: "",
      // 定时刷新token
      refreshTokenTimerId: null,
      // 用户菜单悬浮控制
      userMenuVisible: false,
      userMenuHideTimer: null,
      updatepwdForm: {
        password0: "",
        password: "",
        password2: ""
      },
      pwd_change_form_check_re: false,
      rules: {
        password0: [{required: true, message: '请输入密码', trigger: 'blur'},],
        password: [{validator: this.checkPWD, required: true, trigger: 'blur'},],
        password2: [{validator: this.checkPWD, required: true, trigger: 'blur'},],

      },

    };
  },

  methods: {
    // 悬浮保持用户菜单显示
    keepUserMenuOpen() {
      if (this.userMenuHideTimer) {
        clearTimeout(this.userMenuHideTimer);
        this.userMenuHideTimer = null;
      }
      this.userMenuVisible = true;
    },
    // 延迟隐藏，避免从触发区到下拉内容的间隙导致闪烁
    delayHideUserMenu() {
      if (this.userMenuHideTimer) {
        clearTimeout(this.userMenuHideTimer);
      }
      this.userMenuHideTimer = setTimeout(() => {
        this.userMenuVisible = false;
        this.userMenuHideTimer = null;
      }, 150);
    },
    loginOut() {
      // 退出功能
      this.$confirm("确定要退出登录？", {
        confirmButtonClass: 'custom-confirm-button',
        cancelButtonClass: 'custom-cancel-button',
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: 'logout-confirm-dialog', // 添加自定义类名用于响应式样式
      }).then(() => {
        var data = {};
        login_out(data).then(
            (res) => {
              console.log(res.data.meta);

            },
            (error) => {
              ElMessage({

                showClose: true,
                message: error,
                type: "warning",
              });
              console.log(error);

            }
        );
        // 清空sessionStorage
        sessionStorage.clear();
        let data2 = {
          userName: '',
        };
        this.$store.commit("setUserInfo", data2);
        this.$store.commit("setUserName", '');

        this.$router.push({name: "Login"});
      });

    },
    to_login() {
      this.$router.push("/Login");
    },
    to_register() {
      this.$router.push("/Register");
    },
    to_index() {
      this.activeNavButton = 'index';
      this.$router.push("/index");
    },
    to_introduce() {
      this.activeNavButton = 'introduce';
      this.$router.push("/introduce");
    },
    to_download() {
      this.activeNavButton = 'download';
      this.$router.push("/download");
    },
    to_my_center() {
      this.$router.push("/my_center");
    },

    // 密码格式验证:rules
    checkPWD(rule, value, callback) {
      console.log("==this.updatepwdForm==", this.updatepwdForm, value);
      if (!value) {
        // this.pwd_change_form_check_re=false;
        callback(new Error('请输入密码'))
      } else {
        const reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,16}$/; //手机号正则表达式
        console.log(reg.test(value))
        if (reg.test(value)) {
          // this.pwd_change_form_check_re=true;
          callback()
        } else {
          // this.pwd_change_form_check_re=false;
          return callback(new Error('必须包含大小写字母、数字、特殊字符长度8-16位之间'))
        }
      }
    },


    //打开支付弹框
    showBuy(buy_type) {
      if (buy_type === 'gr'){
        if(this.gr_sale_flag === '0'){
          ElMessage({
            showClose: true,
            message: '暂未开售',
            type: "warning",
          });
          return
        }
      }
      if (buy_type === 'zy'){
        if(this.zy_sale_flag === '0'){
          ElMessage({
            showClose: true,
            message: '暂未开售',
            type: "warning",
          });
          return
        }
      }

      this.buyBoxShow = true;
      this.buyReShow = false;
      this.version_card_click(this.pay_price_bj, '1', 365);

    },

    // 查询支付结果
    wx_zf_re_f() {
      var zf_re_url = "http://payapi.yogoo.net/wxzf/result/" + this.wx_ddh.toString() + ".json";
      wx_zf_re(zf_re_url).then(
          (res) => {
            var res_str = res.data.toString();
            if (res_str.includes("Success") && res_str.includes(this.wx_ddh.toString())) {
              // if (1===1) {
              if (this.zfjgTimerId) {
                clearInterval(this.zfjgTimerId);
                this.buyBoxShow = false;
                this.buyReShow = true;

                const now = new Date();
                const year = now.getFullYear();
                const month = (now.getMonth() + 1).toString().padStart(2, '0');
                const day = now.getDate().toString().padStart(2, '0');
                const hours = now.getHours().toString().padStart(2, '0');
                const minutes = now.getMinutes().toString().padStart(2, '0');
                const seconds = now.getSeconds().toString().padStart(2, '0');
                var pay_date = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

                var data = {
                  user_guid: this.username,
                  // 订单号
                  order_id: this.wx_ddh,
                  // 订单类型
                  product_id: this.order_type,
                  // 订单金额
                  pay_price: this.pay_price*this.zy_discount_rate/10,
                  // 订单折扣
                  discount_rate: this.zy_discount_rate,
                  // 付款时间
                  pay_time: pay_date,
                  // 付款类型
                  pay_type: "0",
                  pay_days: "365",

                };
                // 支付记录传入后台
                order_bill_create(data).then(
                    (res) => {
                      console.log(res.data.meta);
                      if (res.data.meta.code == 200) {
                        console.log("订单支付成功");
                        //  ElMessage({
                        //   showClose: true,
                        //   message: "订单支付成功",
                        //   type: "warning",
                        // });
                        location.reload();
                      } else {
                        console.log("订单支付异常");
                        // ElMessage({
                        //
                        //   showClose: true,
                        //   message: "订单支付异常",
                        //   type: "warning",
                        // });
                      }
                    },
                    (error) => {

                      ElMessage({
                        showClose: true,
                        message: "订单支付失败",
                        type: "warning",
                      });
                      console.log(error);
                    }
                );

              }

              // console.log("==this.zfjgTimerId==",this.zfjgTimerId)
            }

          },
          (error) => {
            console.log(error);
          }
      );
      if (!this.buyBoxShow) {
        if (this.zfjgTimerId) {
          clearInterval(this.zfjgTimerId);
        }
      }
    },

    // 购买订单qr生成
    version_card_click(pay_price, pay_type, pay_days) {
      if (this.zfjgTimerId) {
        clearInterval(this.zfjgTimerId);
      }
      const now = new Date();
      const year = now.getFullYear().toString().padStart(2, '0');
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const day = now.getDate().toString().padStart(2, '0');
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const seconds = now.getSeconds().toString().padStart(2, '0');

      // console.log(`${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      this.order_type = pay_type;
      this.pay_price = pay_price;
      this.pay_days = pay_days;
      var ddg_date = year.toString() + month.toString() + day.toString() + hours.toString() + minutes.toString() + seconds.toString();
      this.wx_ddh = "T" + ddg_date.toString() + this.userid;
      this.pay_qr_code =
          "http://payapi.yogoo.net/wxzf/zfcs/MakeQRCode.aspx?wx_body=悦宝平台订单&wx_total_fee=" + this.pay_price *this.zy_discount_rate/10 * 100 +
          "&wx_ddh=" + this.wx_ddh;
      if (pay_type === '0') {

        this.version_card_bnk_00 = "version_card_chose";
        this.version_card_bnk_01 = "version_card_chose_01";
        this.version_card_bnk_02 = "version_card_chose_02";
        this.version_card_bnk_03 = "version_card_chose_03";
        this.version_card_bnk_04 = "version_card_chose_04";

        this.version_card_nk_00 = "version_card_unset";
        this.version_card_nk_01 = "version_card_unset_01";
        this.version_card_nk_02 = "version_card_unset_02";
        this.version_card_nk_03 = "version_card_unset_03";
        this.version_card_nk_04 = "version_card_unset_04";
      } else {

        this.version_card_bnk_00 = "version_card_unset";
        this.version_card_bnk_01 = "version_card_unset_01";
        this.version_card_bnk_02 = "version_card_unset_02";
        this.version_card_bnk_03 = "version_card_unset_03";
        this.version_card_bnk_04 = "version_card_unset_04";

        this.version_card_nk_00 = "version_card_chose";
        this.version_card_nk_01 = "version_card_chose_01";
        this.version_card_nk_02 = "version_card_chose_02";
        this.version_card_nk_03 = "version_card_chose_03";
        this.version_card_nk_04 = "version_card_chose_04";

      }

      // 创建定时器，每2秒执行一次updateMessage方法
      this.zfjgTimerId = setInterval(this.wx_zf_re_f, 2000);

    },

    // 个人信息查询
    get_sys_user_me() {
      sys_user_me().then(
          (res) => {
            console.log("==get_sys_user_me==", res)
            this.username = res.data.data[0]["user_guid"];
            this.nickname = res.data.data[0]["username"];
            this.acc_type_zh = res.data.data[0]["acc_type_zh"];
            this.acc_type = res.data.data[0]["acc_type"];
            this.userid = res.data.data[0]["user_guid"];
            this.expiration_date = res.data.data[0]["expired_time"].toString().slice(0, 10);

            if (res.data.data[0]["acc_type"] === '1') {
              this.my_version_class = "my_version_yx";
              this.my_xf_btn = true;
            } else {
              this.my_version_class = "my_version_wx";
              this.my_xf_btn = false;
            }


          },
          (error) => {
            ElMessage({
              showClose: true,
              message: error,
              type: "warning",
            });
          }
      );
    },

    // 刷新token
    refresh_token_fun() {
      refresh_token().then(
          (res) => {
            this.$store.commit("setToken", res.data.token);
            // this.$store.commit("setUserName", this.uname);
            // this.$store.commit("setLoginType", "admin");
            // this.$router.push("/index");
          },
          (error) => {
            ElMessage({
              showClose: true,
              message: error,
              type: "warning",
            });
          }
      );
    },


    // 查询年卡、半年卡 价格
    get_sys_app_get_price() {
      var data = {
        "product_id": '0'
      };
      product_price(data).then(
          (res) => {
            this.pay_price_jc = res.data.data.price_num;
            this.gr_sale_flag = res.data.data.sale_flag;
          },
          (error) => {
            ElMessage({
              showClose: true,
              message: error,
              type: "warning",
            });
          }
      );

      var data2 = {
        "product_id": '1'
      };
      product_price(data2).then(
          (res) => {
            this.pay_price_bj = res.data.data.price_num;
            this.zy_sale_flag = res.data.data.sale_flag;
            this.zy_discount_flag = res.data.data.discount_flag;
            if (res.data.data.discount_flag === '1'){
              this.zy_discount_rate = res.data.data.discount_rate;
            }
          },
          (error) => {
            ElMessage({
              showClose: true,
              message: error,
              type: "warning",
            });
          }
      );

    },

  },
  watch: {
    $route() {

    },
  },
  mounted() {
    // 每隔10分钟刷新一次token
    this.refreshTokenTimerId = setInterval(() => {
      // 仅在已登录情况下刷新
      // if (this.$store && this.$store.getters && this.$store.getters.getUserName) {
      if (this.username) {
        this.refresh_token_fun();
      }
    }, 5 * 60 * 1000);
  },
  beforeUnmount() {
    if (this.refreshTokenTimerId) {
      clearInterval(this.refreshTokenTimerId);
      this.refreshTokenTimerId = null;
    }
  },
  created() {

    this.username = this.$store.getters.getUserName;

    // 处理
    if (this.username) {
      this.get_sys_user_me();
      this.get_sys_app_get_price();
    }

  },
  computed: {},
};
</script>

<style scoped>

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 78px;
  width: 100%;
}

.title_box {
  color: white;
  height: 78px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
}

.title_box_img {
  height: 32px;
  cursor: pointer;
  width: 180px;
}

.dlzc_box {
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: white;
  height: 78px;
  flex-wrap: wrap;
  gap: 10px;
}

.header_button {
  cursor: pointer;
  font-size: 16px !important;
  color: #040404;
  margin-right: 20px;
  font-weight: 400;
}

.header_button_active {
  color: #BA0B0B !important;
}

.register_btn {
  background-color: #BA0B0B;
  border-color: #BA0B0B;
  color: #FFFFFF;
  border-radius: 4px;
  font-size: 16px;
  height: 32px;
  width: 106px;
  line-height: 32px;
  padding: 0 14px;
  margin-left: 10px;
}

/deep/ .register_btn:hover,
/deep/ .register_btn:focus,
/deep/ .register_btn:active {
  background-color: #BA0B0B !important;
  border-color: #BA0B0B !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}

.login_btn {
  background-color: #FFFFFF;
  border-color: #BA0B0B;
  color: #BA0B0B;
  border-radius: 4px;
  font-size: 16px;
  height: 32px;
  width: 106px;
  line-height: 32px;
  padding: 0 14px;
  margin-left: 10px;
}

/deep/ .login_btn:hover,
/deep/ .login_btn:focus,
/deep/ .login_btn:active {
  background-color: #FFFFFF !important;
  border-color: #BA0B0B !important;
  color: #BA0B0B !important;
  box-shadow: none !important;
}

.my_version_yx {
  font-size: 16px;
  color: #BA0B0B;
  font-weight: bold;
  padding-top: 10px;
  padding-left: 10px;
}


.my_version_wx {
  font-size: 16px;
  color: #040404;
  font-weight: bold;
  padding-top: 10px;
  padding-left: 10px;
}

.xf_btn {
  background-color: #BA0B0B;
  border-color: #BA0B0B;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 400;
}

/deep/ .xf_btn:hover,
/deep/ .xf_btn:focus,
/deep/ .xf_btn:active {
  background-color: #BA0B0B !important;
  border-color: #BA0B0B !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}

.gm_btn {
  font-size: 14px;
  font-weight: 400;
}

/deep/ .gm_btn:hover,
/deep/ .gm_btn:focus,
/deep/ .gm_btn:active {
  background-color: #FFFFFF !important;
  border-color: #BA0B0B !important;
  color: #BA0B0B !important;
  box-shadow: none !important;
}


.user-dropdown {
  display: flex;
  align-items: center;
}

.el-dropdown-link {
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  font-size: 16px;
  color: #040404;
}


.el-dropdown-link img {
  width: 0.5rem;
  margin-right: 0.125rem;
}

.el-dropdown-link i {
  margin-left: 0.125rem;
}

/deep/ .el-form-item__label {
  color: #222222;
}

/deep/ .el-dialog__title {
  color: #222222;
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #E9E9E9;
  padding-top: unset;
  padding-bottom: unset;
  line-height: 68px;
}

/deep/ .el-dialog__footer {
  border-top: 1px solid #E9E9E9;
  padding-top: unset;
  padding-bottom: unset;
}

.my_center {
  width: 240px;
  height: 120px;

  /*border-radius: 4px;*/
}

.my_center_top {
  width: 100%;
  height: 50%;
  background-color: #FEEFEF;
}

.my_center_bottom {
  width: 100%;
  height: 50%;
  color: #777777;
  font-size: 14px;
}


.my_date {
  font-size: 12px;
  color: #777777;
  padding-top: 5px;
  padding-left: 10px;

}

.my_cz_box {
  height: 40px;
  width: 79px;
  text-align: center;
  margin-top: 15px;
  margin-bottom: 10px;
  display: inline-block
}

/*支付相关开始*/
.version_card_box {
  height: 150px;
  text-align: center;
  margin: 0 auto;
  border-bottom: solid 1px #EEEEEE;
  margin-bottom: 20px;
}

.version_card {
  text-align: center;
  width: 180px;
  height: 100px;
  padding-top: 20px;
  border-radius: 5px;
}

.version_pay_box {
  height: 180px;
  width: 400px;
  margin: 0 auto;
}

.version_pay_qrcode {
  width: 140px;
  height: 155px;
  border: solid 1px #EEEEEE;
  padding: 10px;
  text-align: center;
  float: left;
}

.version_pay_right {
  width: 200px;
  height: 155px;
  float: left;
  padding-top: 20px;
  padding-left: 20px;
}

.version_card_chose {
  background-color: #FDECEC;
  border: 1px solid #F37070;
  width: 25%; /* 或具体宽度 */
  margin-left: auto;
  margin-right: auto;
  display: inline-block; /* 或 display: block; */
}

.version_card_unset {
  background-color: #FFFFFF;
  border: 1px solid #D2D2D2
}

.version_card_chose_01 {
  display: block;
  color: #682020;
  line-height: 22px;
}

.version_card_chose_02 {
  display: block;
  color: #682020;
  line-height: 14px;
  margin-bottom: 10px
}

.version_card_chose_03 {
  display: block;
  color: #EF4444;
  line-height: 30px;
}

.version_card_chose_04 {
  font-size: 18px;
  font-weight: 600
}

.version_card_unset_01 {
  display: block;
  color: #717171;
  line-height: 22px;
}

.version_card_unset_02 {
  display: block;
  color: #717171;
  line-height: 14px;
  margin-bottom: 10px
}

.version_card_unset_03 {
  display: block;
  color: #222222;
  line-height: 30px;
}

.version_card_unset_04 {
  font-size: 18px;
  font-weight: 600
}

/deep/ .el-scrollbar {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2)
}

/*支付相关结束*/

.xl-grzx-tag-icon {
  width: 14px;
  height: 14px;
}

.custom-confirm-button {
  background-color: #BA0B0B !important;
  border-color: #BA0B0B !important;
}

.custom-cancel-button {
  background-color: #BA0B0B !important;
  border-color: #BA0B0B !important;
}

/* 响应式媒体查询 */
@media (max-width: 1200px) {
  .header-container {
    padding: 0 5%;
  }

  .dlzc_box {
    gap: 5px;
  }

  .header_button {
    margin-right: 10px;
    font-size: 14px !important;
  }

  .register_btn, .login_btn {
    width: 80px;
    font-size: 14px;
    margin-left: 5px;
  }
}

@media (max-width: 768px) {
  .header-container {
    flex-wrap: wrap;
    height: auto;
    min-height: 78px;
    padding: 10px 5%;
    gap: 10px;
  }

  .title_box {
    flex-basis: 100%;
    height: auto;
    text-align: center;
  }

  .title_box_img {
    height: 25px;
    width: 120px;
    margin: 0 auto;
  }

  .title_box span {
    font-size: 10px;
    margin-top: 2px;
  }

  .dlzc_box {
    flex-basis: 100%;
    height: auto;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
  }

  .header_button {
    margin-right: 8px;
    font-size: 14px !important;
    padding: 5px 8px;
  }

  .register_btn, .login_btn {
    width: 70px;
    height: 28px;
    font-size: 12px;
    margin-left: 5px;
  }

  .el-dropdown-link {
    font-size: 14px;
    padding: 0.2rem 0.3rem;
  }
  .el-dropdown-link img {
    width: 0.8rem;
    margin-right: 0.125rem;
  }

  .my_center {
    width: 200px;
    height: 100px;
  }

  .my_cz_box {
    width: 60px;
    height: 35px;
    margin-top: 10px;
    margin-bottom: 5px;
  }
}

@media (max-width: 480px) {
  .header-container {
    padding: 8px 3%;
  }

  .dlzc_box {
    gap: 5px;
  }

  .header_button {
    margin-right: 5px;
    font-size: 14px !important;
    padding: 3px 6px;
  }

  .register_btn, .login_btn {
    width: 60px;
    height: 26px;
    font-size: 11px;
    margin-left: 3px;
  }

  .title_box_img {
    height: 20px;
    width: 100px;
  }

  .title_box span {
    font-size: 9px;
  }
}

/* 支付弹窗响应式 */
@media (max-width: 768px) {
  .version_card_box {
    height: auto;
    padding: 20px 10px;
  }

  .version_card {
    width: 100%;
    max-width: 200px;
    height: 80px;
    padding-top: 15px;
    padding-bottom:15px;
  }

  .version_pay_box {
    height: auto;
    width: 100%;
    flex-direction: column;
    gap: 15px;
  }

  .version_pay_qrcode {
    width: 120px;
    height: 140px;
    margin: 0 auto;
  }

  .version_pay_right {
    width: 100%;
    padding: 10px;
    text-align: center;
  }
}

</style>

<style>
/* 响应式支付弹窗样式 */
@media (max-width: 768px) {
  .responsive-dialog {
    max-width: 90vw !important;
  }

  .version_pay_box {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }


  .qrcode-container {
    display: flex;
    justify-content: center;
    height: auto;
  }

  .qrcode-image {
    width: 140px !important;
    max-width: 100%;
  }

  .payment-method {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }

  .payment-icon {
    width: 24px;
    margin-right: 8px;
  }

  .amount-value {
    font-size: 24px;
  }

  .amount-number {
    font-size: 28px !important;
  }
}

/* 通用样式优化 */
.qrcode-image {
  width: 120px;
}

.payment-method {
  display: inline-flex;
  align-items: center;
  height: 24px;
}

.payment-icon {
  width: 24px;
  margin-right: 5px;
  float: left;
}

.payment-text {
  float: left;
  line-height: 24px;
}

.amount-label {
  display: block;
  color: #A9A9A9;
  line-height: 22px;
}

.amount-value {
  display: block;
  color: #EF4444;
  line-height: 30px;
}

.amount-number {
  font-size: 32px;
}

.payment-note {
  display: block;
  color: #434343;
  line-height: 12px;
  margin-bottom: 20px;
}





/* 弹窗响应式 */
@media (max-width: 768px) {
  .qr-content {
    width: 280px;
    padding: 15px;
  }

  .qr-body {
    padding: 15px 30px;
    gap: 15px;
  }

  .qr-title {
    font-size: 18px;
  }

  .qr-title2 {
    font-size: 13px;
  }

  .qr-image {
    width: 160px;
    height: 160px;
  }

  .close-btn {
    font-size: 20px;
    top: 8px;
    right: 8px;
  }
}

/*支付相关开始*/
.version_card_box {
  height: 150px;
  margin: 0 auto;
  border-bottom: solid 1px #EEEEEE;
  margin-bottom: 20px;
  text-align: center;
}

.version_card {
  text-align: center;
  width: 180px;
  height: 100px;
  padding-top: 20px;
  border-radius: 5px;
}

.version_pay_box {
  height: 180px;
  width: 400px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
}

.version_pay_qrcode {
  width: 140px;
  height: 155px;
  border: solid 1px #EEEEEE;
  padding: 10px;
  text-align: center;
  flex-shrink: 0;
}

.version_pay_right {
  width: 200px;
  height: 155px;
  padding-top: 20px;
  padding-left: 20px;
  flex: 1;
}

/* 支付弹窗响应式 */
@media (max-width: 768px) {
  .version_card_box {
    height: auto;
    padding: 20px 10px;
  }

  .version_card {
    width: 100% !important;
    max-width: 200px;
    height: 80px;
    padding-top: 15px;
    padding-bottom:15px;
  }

  .version_pay_box {
    height: auto;
    width: 100%;
    flex-direction: column;
    gap: 15px;
  }

  .version_pay_qrcode {
    width: 120px;
    height: 140px;
    margin: 0 auto;
  }

  .version_pay_right {
    width: 100%;
    height: auto;
    padding: 10px;
    text-align: center;
  }
}

/* 退出登录弹窗响应式 */
@media (max-width: 768px) {
  .zfcg_img{
    width: 26px !important;
  }
  .zfcg_text{
    line-height: 26px !important;
  }
  .logout-confirm-dialog {
    max-width: 90vw !important;
    width: 300px !important;
    margin: 0 auto;
  }

  .logout-confirm-dialog .el-message-box__content {
    padding: 15px 20px;
    font-size: 14px;
  }

  .logout-confirm-dialog .el-message-box__btns {
    padding: 10px 20px 15px;
    display: flex;
    justify-content: center;
    gap: 10px;
  }

  .logout-confirm-dialog .el-button {
    min-width: 80px;
    height: 36px;
    font-size: 14px;
  }



  .logout-confirm-dialog .el-message-box__message {
    padding-left: 30px;
    text-align: left;
  }
}

@media (max-width: 480px) {
  .zfcg_img{
    width: 26px !important;
  }
  .zfcg_text{
    line-height: 26px !important;
  }

  .logout-confirm-dialog {
    width: 280px !important;
  }

  .logout-confirm-dialog .el-message-box__content {
    padding: 12px 15px;
    font-size: 13px;
  }

  .logout-confirm-dialog .el-message-box__btns {
    padding: 8px 15px 12px;
    gap: 8px;
  }

  .logout-confirm-dialog .el-button {
    min-width: 70px;
    height: 32px;
    font-size: 13px;
  }


  .logout-confirm-dialog .el-message-box__message {
    padding-left: 25px;
  }
}

</style>
